module.exports = __webpack_public_path__ + "img/dollarlink.1b085f1e.gif";